export default __webpack_public_path__ + "static/media/422-mark.eff068b2.svg";